import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';

import { RegisterService } from 'src/app/shared/services/register.service';
import { BoobleModalService } from 'booble-modal';
import { SendEmailSuccessModalComponent } from '../responses/modals/send-email-success-modal/send-email-success-modal.component';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-login-reset-password',
  templateUrl: './login-reset-password.component.html',
  styleUrls: ['./login-reset-password.component.scss'],
})
export class LoginResetPasswordComponent implements OnInit {
  private readonly notifier: NotifierService;
  resetPassForm: FormGroup;
  tenant: string = '';
  merchant: string = '';

  public loading: boolean;

  get email(): string {
    return this.resetPassForm.value.email;
  }

  get resetPassControl() {
    return this.resetPassForm.controls;
  }
  isMobile: boolean;

  constructor(
    private readonly fb: FormBuilder,
    private readonly merchantService: MerchantService,
    private readonly registerService: RegisterService,
    notifierService: NotifierService,
    public tenantService: TenantGeneralService,

    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly modalService: BoobleModalService
  ) {
    this.notifier = notifierService;
    this.resetPassForm = fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
    this.merchant = this.merchantService.getLoginMerchant(this.tenant);
  }

  goToLogin() {
    this.router.navigateByUrl(`${this.tenant}/login?m=${this.merchant}`);
  }

  openSendEmailSuccessModal() {
    this.modalService.present(SendEmailSuccessModalComponent);
  }

  sendResetEmail() {
    this.loading = true;
    this.registerService.emailResetPassword(this.email, false).subscribe({
      next: (resetResult) => {
        this.notifier.notify(
          'success',
          'Verifique seu e-mail e caixa de spam.'
        );
        this.loading = false;
        this.isMobile
          ? this.openSendEmailSuccessModal()
          : this.router.navigateByUrl(
              `${this.tenant}/login/send-email-pass-success?m=${this.merchant}`
            );
      },

      error: (err) => {
        this.notifier.notify(
          'error',
          'Erro ao enviar instruções para redefinir a senha!'
        );
        this.loading = false;
      },
    });
  }
}
